import { render, staticRenderFns } from "./candiDateReason.vue?vue&type=template&id=3c4cc0b5&scoped=true&"
import script from "./candiDateReason.vue?vue&type=script&lang=js&"
export * from "./candiDateReason.vue?vue&type=script&lang=js&"
import style0 from "./candiDateReason.vue?vue&type=style&index=0&id=3c4cc0b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4cc0b5",
  null
  
)

export default component.exports